import React from 'react';

// Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

export default function AssignSapIdModal({active, onAdd, onClose, classes}) {
    const [sap_id, setSapId] = React.useState("");

    const handleAdd = () => {
      onAdd(sap_id);
    }

    const handleChangeText = (event) => {
        setSapId(event.target.value);
    };

  return (
      <Dialog open={active} onClose={onClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Assign a sap id</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please, enter the SAP ID of this user.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            name="sap_id"
            label="SAP ID"
            onChange={handleChangeText}
            value={sap_id}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleAdd} color="primary">
            Add
          </Button>
        </DialogActions>
      </Dialog>
    )
}